<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">View List of Pages</div>
      <div>
        <router-link class="btn-blue" :to="'/reports/list-of-pages'">{{
          $t("Add")
        }}</router-link>
      </div>
    </div>
    <div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <table class="list-view-table">
              <thead>
                <tr>
                  <th>Page Name</th>
                  <th>Language</th>
                  <!-- <th>Status</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="pagesData.length > 0">
                <tr v-for="(item, index) in pagesData" :key="index">
                  <td>{{ item.mpm_name }}</td>
                  <td>{{ item.lang_name }}</td>
                  <!-- <td>
                    <StatusDot
                      :status="
                        item.mpm_d_is_active == 'Y' ? 'active' : 'inactive'
                      "
                    />
                  </td> -->
                  <td class="text-right">
                    <b-dropdown right variant="edit" class="ml-4">
                      <b-dropdown-item
                        @click="goToRoute('/reports/list-of-pages/', item)"
                      >
                        <span class="edit-pen"></span>
                        {{ $t("edit") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="pagesData.length == 0">
                <tr>
                  <td colspan="3">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExhibitorService from "@/services/ExhibitorService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  name: "View List of Pages",
  components: {
    StatusDot,
    NoRecords
  },
  data() {
    return {
      pagesData: []
    };
  },
  beforeMount() {
    this.getListOfPages();
  },
  methods: {
    getListOfPages() {
      ExhibitorService.GetListOfPages()
        .then(response => {
          const { data } = response;
          if (data.Records.length > 0) {
            console.log(data.Records);
            // this.pagesData = data.Records;
            let pageData = data.Records;
            this.pagesData = pageData.filter(
              (x, index, self) =>
                index ===
                self.findIndex(
                  t =>
                    t.mpm_name === x.mpm_name && t.mpm_lang_id === x.mpm_lang_id
                )
            )
            .sort((a, b) => {
              let comparison = 0
              const nameA = a.mpm_name.toUpperCase()
              const nameB = b.mpm_name.toUpperCase()

              if (nameA < nameB) comparison = -1
              if (nameA > nameB) comparison = 1

              if(comparison == 0) comparison = (parseInt(b.mpm_lang_id || 0) || 0) - (parseInt(a.mpm_lang_id || 0) || 0)

              return comparison
            });
          } else {
            console.log("data.message", data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { mpm_id } = item;
      this.$router.push({
        path: path,
        query: {
          mpm_id: mpm_id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/viewListOfPages.vue